import React from 'react';
import { AssignmentWizardStepProps } from '../types';
import { toAssignmentWizardData, toAssignmentWizardWithdrawalFormModel } from './mappers';
import AssignmentWizardWithdrawalForm, { AssignmentWizardWithdrawalFormModel } from './AssignmentWizardWithdrawalForm';
import { useAgent } from '../../../../../hooks/use-agent/useAgent';
import { getAgentConfiguration } from '../../../../../utils/agent/getAgentConfiguration';

const AssignmentWizardWithdrawal: React.FC<AssignmentWizardStepProps> = ({
  initialData,
  prospect,
  loading = false,
  formRef,
  onSubmit,
}) => {
  const { data: prospectAgent } = useAgent(prospect.agentId);

  const showCustomPercentages = React.useMemo(() => prospectAgent?.configuration?.digitalAssignment?.customPercentages ?? false, [prospectAgent?.configuration?.digitalAssignment?.customPercentages]);

  const onInternalSubmit = React.useCallback((formValues: AssignmentWizardWithdrawalFormModel) => {
    const values = toAssignmentWizardData(initialData, formValues);

    const isFormDirty = (formRef?.current as any)?.dirty ?? false;

    onSubmit(values, isFormDirty);
  }, [formRef, initialData, onSubmit]);

  return (
    <AssignmentWizardWithdrawalForm
      initialValues={toAssignmentWizardWithdrawalFormModel(initialData, getAgentConfiguration(prospectAgent)?.digitalAssignment)}
      showCustomPercentages={showCustomPercentages}
      formRef={formRef}
      onSubmit={onInternalSubmit}
      loading={loading}
    />
  );
};

export default AssignmentWizardWithdrawal;
